export const PUBLIC_FILES_ROUTE_PREFIX = '/public/';
export const LEAD_FORMS_ROUTE = `${PUBLIC_FILES_ROUTE_PREFIX}:flowId`;
export const LEAD_FORM_EMBED_FLOWS_ROUTE_PREFIX = '/embed/';
export const PUBLIC_EMBED_FLOWS_ROUTE = `${LEAD_FORM_EMBED_FLOWS_ROUTE_PREFIX}:flowId`;
export const PUBLIC_EMBED_FLOW_SUBMITTED_ROUTE = `${LEAD_FORM_EMBED_FLOWS_ROUTE_PREFIX}:flowId/flow-submitted`;
export const ONE_FLOW_ROUTE_PREFIX = '/flow/';
export const VIEW_MODE_FLOW_ROUTE_POSTFIX = '/view';
export const ONE_FLOW_ROUTE = `${ONE_FLOW_ROUTE_PREFIX}:flowId`;
export const VIEW_MODE_FLOW_ROUTE = `${ONE_FLOW_ROUTE}${VIEW_MODE_FLOW_ROUTE_POSTFIX}`;
export const PUBLIC_TEMPLATE_ROUTE_POSTFIX = '/template/view';
export const PUBLIC_TEMPLATE_MODE_FLOW_ROUTE = `${ONE_FLOW_ROUTE}${PUBLIC_TEMPLATE_ROUTE_POSTFIX}`;
export const PUBLIC_TEMPLATE_ROUTE_NEW_ROUTE = '/template-preview/:flowId';
export const LOGOUT_ROUTE = '/logout';
export const CLIENT_NAVIGATION_ROUTE = '/client_navigation';
export const CX_APP_ROUTER_BASE_PATH = '';
export const FLOW_ROUTES = [
    ONE_FLOW_ROUTE,
    VIEW_MODE_FLOW_ROUTE,
    LEAD_FORMS_ROUTE,
    PUBLIC_EMBED_FLOWS_ROUTE,
    LOGOUT_ROUTE,
    PUBLIC_TEMPLATE_ROUTE_NEW_ROUTE
];
